export default __webpack_public_path__ + "static/Important-Notice_EGIB_MY-3f633137a47b2943f1af236f7adfaa14.pdf";